import React from "react";
import { object, bool } from "prop-types";
import { getLastPublishedTime } from "../../utils/story";
import { DotSeparator } from "../Separator";
import "./publish-read-time.m.css";

export const PublishAndReadTime = ({ showReadTime, showTimestamp, story, customStyle = {}, customDotColor }) => {
  const lastPublishedTime = getLastPublishedTime(story?.["last-published-at"]);
  const readTime = story?.["read-time"] || null;

  if (!((showReadTime && readTime) || (showTimestamp && lastPublishedTime))) {
    return null;
  }
  if (showTimestamp && showReadTime) {
    return (
      <div styleName="time-container" style={customStyle}>
        {lastPublishedTime && (
          <span styleName="publish-time">
            {lastPublishedTime}
            {readTime && <DotSeparator customDotColor={customDotColor} />}
          </span>
        )}
        {readTime && <span>{readTime}m read</span>}
      </div>
    );
  }

  if (showReadTime) {
    return (
      <div styleName="time-container" style={customStyle}>
        <span>{readTime}m read</span>
      </div>
    );
  }
  return (
    <div styleName="time-container" style={customStyle}>
      <span styleName="publish-time">{lastPublishedTime}</span>
    </div>
  );
};

PublishAndReadTime.propTypes = {
  story: object,
  showReadTime: bool,
  showTimestamp: bool,
};
